<template>
  <v-container fluid class="mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex flex-start justify-md-start">
              <v-btn color="success" class="button-shadow mr-2" @click="isFindReport=true">
                <v-icon class="mr-2">mdi-file-search</v-icon>
                Find
              </v-btn>
              <v-btn color="success" class="button-shadow mr-2" to="/gl-report/list">
                <v-icon class="mr-2">mdi-check</v-icon>
                Done
              </v-btn>
              <v-btn color="default" class="button-shadow mb-2 mr-0 mr-sm-2" v-on:click="PrintElement('print-page')">
                <v-icon class="mr-2">mdi-printer</v-icon>
                Print
              </v-btn>
              <download-excel
                class="btn btn-default"
                :data="getJson()"
                worksheet="My Worksheet"
                type="csv"
                :name="getFileName()"
              >
              <v-btn 
                v-show="transactions!=null && transactions.length>0"
                color="default" 
                class="button-shadow mb-2 mr-0 mr-sm-2"
              >
                <v-icon class="mr-2">mdi-microsoft-excel</v-icon>
                Save
              </v-btn>
              </download-excel>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12" id="print-page">
        <v-row class="print-page">
          <v-col cols="12" sm="12" md="12" lg="12" >
            <v-card class="ma-1">
              <v-card-text class="printBody">
                <v-row>&nbsp;</v-row>
                <v-row justify="space-between">
                  <table style="width: 100%; margin-right: 10px; margin-left: 10px;">
                    <tr>
                      <td style="width: 100px; vertical-align: top;"><img v-if="logo!=null" :src="logo.src" :height="logo.height" alt="Logo" /></td>
                      <td></td>
                      <td style="width: 35%; text-align: right; vertical-align: text-top">
                         <table v-if="ledger!=null" style="width: 100%">
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Ledger</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt;">{{ ledger.ledgercode }}</span></td>
                          </tr>
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Start Date</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt;">{{ new Date(ledger.startdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}</span></td>
                          </tr>
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">End Date</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt;">{{ new Date(ledger.enddate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}</span></td>
                          </tr>
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Currency</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt;">{{ ledger.primaryCurrency }}</span></td>
                          </tr>
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">SCY</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt;">{{ ledger.secondaryCurrency }}</span></td>
                          </tr>
                         </table> 
                      </td>
                    </tr>
                  </table>
                  <table style="width: 100%; padding-bottom: 10px;">
                    <tr>
                      <td>
                        <div align="center" style="padding: 0; line-height: 0;"><h3><b>General Ledger</b></h3></div>
                        <p align="center" style="padding: 0; line-height: 0;">
                          Period:
                          {{ new Date(ledger.startdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}&nbsp;- 
                          {{ new Date(ledger.enddate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
                        </p>
                      </td>
                    </tr>
                    <tr><td><div style="height: 10px;">&nbsp;</div></td></tr>
                  </table>
                </v-row>
                <table v-if="group_transactions.length>0" style="width: 100%" cellpadding="0" cellspacing="0">
                  <tbody v-for="(group) in group_transactions" v-bind:key="group">
                    <tr v-bind:key="group">
                      <th colspan="2" :style="css['row-bottom-left-sm']">{{ AccountName(group) }}</th>
                      <th :style="css['row-bottom-right']" width="10%">Credit</th>
                      <th :style="css['row-bottom-right']" width="10%">Debit</th>
                      <th :style="css['row-bottom-right']" width="10%">SCY</th>
                    </tr>
                    <tr>
                      <td :style="css['row-left']">{{ new Date(ledger.startdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}</td>
                      <td :style="css['row-left']">Opening Balance</td>
                      <td :style="css['row-right']">{{ sum_opening(group, 'credit') }}</td>
                      <td :style="css['row-right']">{{ sum_opening(group, 'debit') }}</td>
                      <td :style="css['row-right']">{{ OpenFCY(group) }}</td>
                    </tr>
                    <tr v-for="(trans) in data_transactions(group)"  v-bind:key="trans._id">
                      <td :style="css['row-left']">{{ new Date(trans.transdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}</td>
                      <td :style="css['row-left'] + 'width: 60%;'">{{ trans.transdesc }}</td>
                      <td :style="css['row-right']">{{ TransAmount(trans, 'credit') }}</td>
                      <td :style="css['row-right']">{{ TransAmount(trans, 'debit') }}</td>
                      <td :style="css['row-right']">{{ TransAmount2(trans) }}</td>
                    </tr>
                    <tr><td><div style="height: 10px;">&nbsp;</div></td></tr>
                    <tr>
                      <td colspan="2" :style="css['row-top-left']">TOTAL {{ AccountName(group) }}</td>
                      <td :style="css['row-top-right']">{{ SumCredit(group) }}</td>
                      <td :style="css['row-top-right']">{{ SumDebit(group) }}</td>
                      <td :style="css['row-top-right']">{{ SumFCY(group) }}</td>
                    </tr>
                    <tr>
                      <td colspan="2" :style="css['row-mid-left']">Ending Balance {{ AccountName(group) }}</td>
                      <td :style="css['row-mid-right']">{{ sum_closing(group, 'credit') }}</td>
                      <td :style="css['row-mid-right']">{{ sum_closing(group, 'debit') }}</td>
                      <td :style="css['row-mid-right']">{{ CloseFCY(group) }}</td>
                    </tr>
                    <tr>
                      <td colspan="5" :style="css['row-mid-left']">&nbsp;</td>
                    </tr>
                  </tbody>
                </table>
                <p style="margin-top: 0; margin-bottom: 70px">&nbsp;</p>
                <p style="margin-top: 0; margin-bottom: 0">&nbsp;</p>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <div>
    <v-dialog
      v-model="isFindReport"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Find Report</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
              >
                <v-select
                  dense
                  :items="glledgers.map(x => {
                            return {text: x.ledgername, value: x._id};
                          })"
                  v-model="find_query.ledgerid"
                  label="Ledger"
                  required
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="12"
              >
                <v-select
                  dense
                  :items="accounts.map(x => {
                            return {text: x.accountname, value: x._id};
                          })"
                  v-model="find_query.accountid"
                  label="Account"
                  required
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-menu
                  ref="menu_startdate"
                  v-model="menu_startdate"
                  :close-on-content-click="false"
                  :return-value.sync="find_query.startdate"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      dense
                      v-model="find_query.startdate"
                      label="Start Date"
                      v-bind="attrs"
                      v-bind:value="find_query.startdate"
                      v-on:change="onChangeDate($event, 'start')"
                      v-on="on"
                      persistent-hint
                      single-line hint="Please enter start date">
                    </v-text-field>
                  </template>
                  <v-date-picker
                    v-model="find_query.startdate"
                    no-title
                    scrollable
                  >
                  <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="primary"
                      @click="menu_startdate = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="onChangeDate(find_query.startdate, 'start'); $refs.menu_startdate.save(find_query.startdate)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-menu
                  ref="menu_enddate"
                  v-model="menu_enddate"
                  :close-on-content-click="false"
                  :return-value.sync="find_query.enddate"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      dense
                      v-model="find_query.enddate"
                      label="End Date"
                      v-bind="attrs"
                      v-bind:value="find_query.enddate"
                      v-on:change="onChangeDate($event, 'end')"
                      v-on="on"
                      persistent-hint
                      single-line hint="Please enter end date">
                    </v-text-field>
                  </template>
                  <v-date-picker
                    v-model="find_query.enddate"
                    no-title
                    scrollable
                  >
                  <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="primary"
                      @click="menu_enddate = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="onChangeDate(find_query.enddate, 'end'); $refs.menu_enddate.save(find_query.enddate)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isFindReport = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="resetReport"
          >
            Reset
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="findReport"
          >
            Find
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
  </v-container>
</template>

<script>
    import {mapActions, mapState} from "vuex";
    import { getLogo, getFirstDay, getLastDay, formatStdDate } from '../../../util/tools';
    export default {
        name: 'PrintPage',
        data(){
          return {
            logo: null,
            companycode: null,
            reportname: 'GL', 
            accountname: 'All', 
            isFindReport: false,
            menu_startdate: null,
            menu_enddate: null,
            digits: null,
            ledger: {},
            find_query: {},
            transactions: [],
            css: {
              'row-top-right': 'padding: 2px; text-align: right; border-top: 2px; border-top-style: solid; font-size:10pt;',
              'row-mid-right': 'padding: 2px; text-align: right; border-top: 2px; border-top-style: none; font-size:10pt;',
              'row-mid-left': 'padding: 2px; text-align: left; border-top: 2px; border-top-style: none; font-size:10pt; font-weight: bold;',
              'row-top-left': 'padding: 2px; text-align: left; border-top: 2px; border-top-style: solid; font-size:10pt; font-weight: bold;',
              'row-bottom-right': 'padding: 2px; text-align: right; border-bottom: 1px; border-bottom-style: solid;',
              'row-bottom-left': 'padding: 2px; text-align: left; border-bottom: 1px; border-bottom-style: solid;',
              'row-bottom-left-sm': 'width:18%; padding: 2px; text-align: left; border-bottom: 1px; border-bottom-style: solid;',
              'row-left': 'text-align: left; padding-top: 2px; padding-bottom: 2px; padding-right: 12px; font-size:10pt;',
              'row-right': 'text-align: right; padding: 3px; font-size:10pt;',
            },
            formatStdDate: formatStdDate,
          };
        },
        computed: {
          ...mapState('Account', ['accounts']),
          ...mapState('GLLedger', ['glledgers']),
          group_transactions(){
            let array1 = [];
            let array2 = [];
            if(this.ledger==null && this.transactions==null) return [];
            if(this.transactions.length>0) array1 = this.transactions.map((trans)=>{return {accountid: trans.accountid, accountnum: trans.accountnum}});
            if(this.ledger.opening_balances!=null && this.ledger.opening_balances.length>0) array2 = this.ledger.opening_balances.map((trans)=>{return {accountid: trans.accountid, accountnum: trans.accountnum}});
            
            let combined = array1.concat(array2);
            combined.sort((a,b) =>{
              if (b.accountnum > a.accountnum) return -1;
              if (a.accountnum < b.accountnum) return 1;
              return 0;
            });

            let object1 = Object.groupBy(combined, item => { return item.accountid});
            let results = Object.keys(object1);

            return results;
          },
        },
        methods: {
          ...mapActions('Account', ['getAccountsRequest']),
          ...mapActions('GLLedger', ['getGLLedgersRequest']),
          ...mapActions('GLReport', ['findGLReportGLRequest', 'getGLReportGLRequest']),
          ...mapActions('SystemSetting', ["getSetting"]),
          PrintElement(divid) {
            var content = document.getElementById(divid).innerHTML;
            var mywindow = window.open('', 'Print', 'height=800,width=1000,menubar=0,location=0,status=0,titlebar=0,toolbar=0');

            mywindow.document.write('<html>');
            mywindow.document.write('<head><title>'+ `${this.companycode} ${this.reportname} ${this.accountname} ${ this.formatStdDate(this.ledger.startdate) }_${ this.formatStdDate(this.ledger.enddate) }` + '</title></head>');
            mywindow.document.write('<body onclick="window.print();">');  
            mywindow.document.write(content);
            mywindow.document.write('</body>');
            mywindow.document.write('</html>');
            mywindow.document.close();
            mywindow.focus()
            mywindow.print();
            return;
          },
          data_transactions(id){
            let result = this.transactions.filter(trans=>trans.accountid==id);
            return result;
          },
          sum_opening(id, type){
            let result;
            let open = this.ledger.opening_balances.find(item=>item.accountid==id);
            if(open==undefined) result = '';
            else{
              if(open['accounttype']=='Credit' && type=='credit') result = open.creditAmount-open.debitAmount;
              else if(open['accounttype']=='Debit' && type=='debit') result = open.debitAmount-open.creditAmount;
              else result = '';
            }

            if(result!=null & result!='') return result.toLocaleString("en-US", { minimumFractionDigits: this.digits, maximumFractionDigits: this.digits });
            return result;
          },
          sum_closing(id, type){
            let result;
            let transactions = this.data_transactions(id);
            let open = this.ledger.opening_balances.find(item=>item.accountid==id);
            if(transactions==null && open==null) return;
            let open_credit = open!=null ? open.creditAmount : 0;
            let open_debit = open!=null ? open.debitAmount : 0;
            
            let credit = transactions.reduce((a, b) => a + (b.creditAmount), 0);
            let debit = transactions.reduce((a, b) => a + (b.debitAmount), 0);
            if(open==null){
              let account_type = this.AccountType(id);
              if(type=='credit' && account_type=='Credit') result = credit - debit;
              else if(type=='debit' && account_type=='Debit') result = debit - credit;
              else result = '';
            }
            else if(transactions.length==0){
              let account_type = this.AccountType(id);
              if(account_type=='Credit' && type=='credit') result = open_credit - open_debit;
              else if(account_type=='Debit' && type=='debit') result = open_debit - open_credit;
              else result = '';
            }
            else {
              if(open['accounttype']=='Credit' && type=='credit') result = open_credit + credit - open_debit - debit;
              else if(open['accounttype']=='Debit' && type=='debit') result = open_debit + debit - open_credit - credit;
              else result = '';
            }
            if(result!=null & result!='') result = result.toLocaleString("en-US", { minimumFractionDigits: this.digits, maximumFractionDigits: this.digits });
            else result = '';
            
            return result;
          },

          AccountName(id){
            let result = this.accounts.find(account=>account._id==id);
            return result!=null ? `${result.accountnum}: ${result.accountname}` : '';
          },
          AccountNameMin(id){
            let result = this.accounts.find(account=>account._id==id);
            return result!=null ? `${result.accountname}` : '';
          },
          AccountType(id){
            let result = this.accounts.find(account=>account._id==id);
            return result!=null ? result.accounttype : '';
          },
          SumCredit(id){
            let transactions = this.data_transactions(id);
            let result = transactions.reduce((a, b) => a + (b.creditAmount), 0);
            result = result.toLocaleString("en-US", { minimumFractionDigits: this.digits, maximumFractionDigits: this.digits });
            return result;
          },
          SumDebit(id){
            let transactions = this.data_transactions(id);
            let result = transactions.reduce((a, b) => a + (b.debitAmount), 0);
            result = result.toLocaleString("en-US", { minimumFractionDigits: this.digits, maximumFractionDigits: this.digits });
            return result;
          },
          SumFCY(id){
            let type = this.AccountType(id);
            let result;
            let transactions = this.data_transactions(id);
            if(type=='Credit') result = transactions.reduce((a, b) => a + (b.creditAmount2-b.debitAmount2), 0);
            else result = transactions.reduce((a, b) => a + (b.debitAmount2-b.creditAmount2), 0);
            result = result.toLocaleString("en-US", { minimumFractionDigits: this.digits, maximumFractionDigits: this.digits });
            return result;
          },
          OpenFCY(id){
            let result;
            let type = this.AccountType(id);
            let open = this.ledger.opening_balances.find(item=>item.accountid==id);
            let open_credit = open!=null ? open.creditAmount2 : 0;
            let open_debit = open!=null ? open.debitAmount2 : 0;

            if(type=='Credit') result = open_credit - open_debit;
            else result = open_debit - open_credit;
            result = result.toLocaleString("en-US", { minimumFractionDigits: this.digits, maximumFractionDigits: this.digits });
            return result;
          },
          CloseFCY(id){
            let result;
            let sum;
            let type = this.AccountType(id);
            let open = this.ledger.opening_balances.find(item=>item.accountid==id);
            let open_credit = open!=null ? open.creditAmount2 : 0;
            let open_debit = open!=null ? open.debitAmount2 : 0;

            let transactions = this.data_transactions(id);
            if(type=='Credit') sum = transactions.reduce((a, b) => a + (b.creditAmount2-b.debitAmount2), 0);
            else sum = transactions.reduce((a, b) => a + (b.debitAmount2-b.creditAmount2), 0);

            if(type=='Credit') result = open_credit - open_debit +  sum;
            else result = open_debit - open_credit +  sum;
            result = result.toLocaleString("en-US", { minimumFractionDigits: this.digits, maximumFractionDigits: this.digits });
            return result;
          },

          TransAmount(trans, type){
            let result;
            if(type=='credit') result = trans.creditAmount;
            else if(type=='debit') result = trans.debitAmount;
            else result = 0;
            result = result.toLocaleString("en-US", { minimumFractionDigits: this.digits, maximumFractionDigits: this.digits });
            return result;
          },

          TransDebit(trans){
            let result;
            result = trans.debitAmount;
            result = result.toLocaleString("en-US", { minimumFractionDigits: this.digits, maximumFractionDigits: this.digits });
            return result;
          },
          TransAmount2(trans){
            let result;
            if(trans==null) return '';
            if(trans['accounttype']=='Credit') result = trans.creditAmount2-trans.debitAmount2;
            else result = trans.debitAmount2-trans.creditAmount2;
            result = result.toLocaleString("en-US", { minimumFractionDigits: this.digits, maximumFractionDigits: this.digits });
            return result;
          },
          resetReport(){
            this.find_query = {};
          },
          async findReport(){
            
            let data = await this.findGLReportGLRequest(this.find_query);
            this.ledger = Object.assign([], data);
            this.transactions = Object.assign([], data.transactions);
            if(this.find_query.accountid!=null) this.accountname = this.AccountNameMin(this.find_query.accountid);
            else this.accountname = 'All';
            this.isFindReport = false;
          },
          onChangeDate(value, route) {
            let date = new Date(value);
            let start_date = getFirstDay(date);
            let end_date = getLastDay(date);

            if(route=='start') this.find_query = Object.assign({}, this.find_query, {startdate: start_date});
            if(route=='end') this.find_query = Object.assign({}, this.find_query, {enddate: end_date});
          },
          getFileName(){
            var name = `${this.ledger.ledgercode} GL` + ' ' + `${formatStdDate(this.ledger.startdate)} - ${formatStdDate(this.ledger.enddate)}` ;
            return name + '.csv';
          },
          getJson(){
            let json = this.transactions.map(item=>{return {
              transdate: formatStdDate(item.transdate),
              accountclass: item.accountclass,
              accountsubclass: item.accountsubclass,
              accountnum: item.accountnum,
              accountname: item.accountname,
              description: item.transdesc,
              creditAmount: item.creditAmount,
              debitAmount: item.debitAmount,
              creditAmount2: item.creditAmount2,
              debitAmount2: item.debitAmount2,
              rate: item.currencyRate,
            }});
            return json;
          },
        },
        async created () {
          let data = await this.getGLReportGLRequest();
          if(this.glledgers.length==0)await this.getGLLedgersRequest();
          if(this.accounts.length==0) await this.getAccountsRequest();

          this.ledger = Object.assign([], data);
          this.transactions = Object.assign([], data.transactions);


          var companyid = localStorage.getItem("companyid");
          this.companycode = localStorage.getItem("companycode");
          this.logo = getLogo(companyid);
          let decimal = await this.getSetting({code: 'CurrencySettings', name: 'PrimaryDecimalPlaces'}, );
          this.digits = parseInt(decimal);
        },
    };
</script>

<style src="./Print.scss" lang="scss" scoped />
